import { Injectable } from '@angular/core';
import { GoJsSearchNode } from '@y42/gojs';
import { DataLineageSelectedFilter } from '@y42/json-schema';
import { DataLineageDiagramUIModel, DataLineageUINode } from './data-lineage-diagram.model';
import { DataLineageDiagramStore } from './data-lineage-diagram.store';

@Injectable({ providedIn: 'root' })
export class DataLineageDiagramStoreService {
  constructor(private readonly store: DataLineageDiagramStore) {}

  setActiveNode(activeNode: DataLineageUINode | null) {
    this.store.update({
      activeNode,
    });
  }

  setDataLoading(dataLoading: boolean) {
    this.store.update({
      dataLoading,
    });
  }

  setSearchNodes(searchNodes: GoJsSearchNode[]) {
    this.store.update({
      searchNodes,
    });
  }

  setOutputModel(outputModel: DataLineageDiagramUIModel | null) {
    this.store.update({
      outputModel,
    });
  }

  setFilters(filters: DataLineageSelectedFilter[]) {
    this.store.update({
      filters,
    });
  }

  setHighlights(highlights: DataLineageSelectedFilter[]) {
    this.store.update({
      highlights,
    });
  }

  setInputModel(inputModel: DataLineageDiagramUIModel) {
    this.store.update({
      inputModel,
    });
  }
}
